module.exports = __webpack_public_path__ + "img/confrim.ff3d052f.png";